import React, { useEffect, useState } from 'react';
import { useAsync } from 'react-use';
import { useSelector, useDispatch } from 'react-redux';
import { loadSceneGridData, loadAnalyticsData } from '../../actions';
import { loadScenes } from '../../lib/algolia.js';
import { getParameter, getLargestPicture } from "../../lib/utils.js";
import getAnalytics from '../../lib/analytics';
import arrayMove from 'array-move';


const SceneGridData = ({ children }) => {

  const { lpdata: landingPageData, category, analyticsMode, slug, sitetag } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const data = useAsync(async() => getContent(landingPageData, category), [landingPageData, category]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [analyticsLoaded, setAnalyticsLoaded] = useState(false);

  useEffect(() => {
    if (data.value && !dataLoaded) {
      setDataLoaded(true);
      dispatch(loadSceneGridData(optimizeData(data.value, landingPageData)));
    }
    if (analyticsMode && !analyticsLoaded) {
      setAnalyticsLoaded(true);
      getAnalytics(slug, sitetag).then(data => {
        dispatch(loadAnalyticsData(data));
      });
    }
  }, [analyticsMode, analyticsLoaded, data.value, dataLoaded, slug, sitetag, landingPageData, dispatch]);

  
  //console.log(data);
  if (data.loading === true) return (<div>Loading</div>);
  else if (data.error) { return (<div>Error: {data.error.message}</div>) }
  else if (!data.value) return null;
  else return children;

};

export default SceneGridData;




const getContent = async(landingPageData, category) => {
  //console.log(landingPageData)
  let { siteScenesFilter, numberOfScenes, scenesFilter, scenesSorting, scenesOverride, segment } = landingPageData;
  let additionalScenes = [];
  /* eslint no-template-curly-in-string: "off" */
  let filter = (scenesFilter || '${default}').replace("${default}", `(${siteScenesFilter})`);
  let index = scenesSorting || "all_scenes";
  let numItems = numberOfScenes;

  if (category) filter = `(${filter}) AND categories.name:'${category}'`;

  //find out if we need to retrieve data about additional scenes
  (scenesOverride || []).map(item => {
    if (item.clip_id) additionalScenes.push(item.clip_id);
    return null;
  });

  //find out if content continuation
  let ar = parseInt(getParameter("ar"), 10) || null;
  if (ar) additionalScenes.push(ar);
  //console.log(filter)
  return loadScenes(segment, filter, numItems, index, additionalScenes);

};

const optimizeData = (data, landingPageData) => {
  let { scenesOverride, videoAutoPlayPositions, banners } = landingPageData;

  //clean the thumbnail path for largest format
  if (!data.map) return [];
  data = data.map(item => {
    item.thumbnail = getLargestPicture(item.pictures);
    return item;
  });

  //we create a content map and position map
  let contentMap = {};
  let positionMap = [];
  data.map((item) => {
    if (!contentMap[item.clip_id]) positionMap.push(item.clip_id);
    contentMap[item.clip_id] = item;
    return null;
  });

  (scenesOverride || []).map(item => {
    if (contentMap[item.clip_id]) {
      if (item.position !== undefined) arrayMove.mutate(positionMap, positionMap.indexOf(item.clip_id), item.position - 1);
      if (item.videoSrc) contentMap[item.clip_id].videoSrc = item.videoSrc;
      if (item.imageSrc) contentMap[item.clip_id].imageSrc = item.imageSrc;
      if (item.ratio) contentMap[item.clip_id].ratio = item.ratio;
      contentMap[item.clip_id].type = 'override';
    }
    return null;
  });

  //apply if content continuation
  let ar = parseInt(getParameter("ar"), 10) || null;
  if (ar && contentMap[ar]) {
    arrayMove.mutate(positionMap, positionMap.indexOf(ar), 0);
  }

  //rebuild content array
  data = positionMap.map(item => contentMap[item]);

  //enable video autoplay
  if (videoAutoPlayPositions) {
    videoAutoPlayPositions.map(pos => {
      if (data[pos - 1]) data[pos - 1].mode = 'video';
      return null;
    });
  }
  //position banners
  (banners || []).map((item, arrayPos) => {
    let elem = { ...item };
    elem.type = 'banner';
    elem.arrayPos = arrayPos;
    if (elem.position) {
      data.splice(elem.position - 1, 0, elem);
    }
    else {
      data.push(elem);
    }
    return null;
  });
  return data;
};
